import React, { createContext, FC, useContext } from "react";
import { ResourceSelectorContextType } from "./types";

const ResourceSelectorContext = createContext<ResourceSelectorContextType>({});

export const ResourceSelector: FC<ResourceSelectorContextType> = ({
  onClose,
  onSelect,
  zIndex,
  resourceType,
  active,
  selectedResourceName,
  children,
}) => {
  const value: ResourceSelectorContextType = {
    onClose,
    onSelect,
    zIndex,
    resourceType,
    active,
    selectedResourceName,
  };

  return <ResourceSelectorContext.Provider value={value}>{active && children}</ResourceSelectorContext.Provider>;
};

export const useResourceSelectorContext = (): ResourceSelectorContextType => {
  return useContext(ResourceSelectorContext);
};
